import React from 'react';
import { Form, Formik, Field } from 'formik';
import * as Yup from 'yup';
import {
  FormButtons,
  FormRow,
  FileUpload,
  DateFormWidget,
  Map,
} from '../controls';

const AttractionSchema = Yup.object().shape({
  attractionName: Yup.string().required('Attraction name is required'),
});

export function AttractionForm({
  attraction,
  onDateChange,
  handleSave,
  handleRemove,
  onLocationChange,
  onFileUpload,
  onFileDelete,
}) {
  const { startTime, startTimeMS, endTime, endTimeMS } = attraction;
  const defaultValues = {
    attractionName: attraction.attractionName || '',
    attractionDescription: attraction.attractionDescription || '',
  };
  const dates = [{ startTime, startTimeMS, endTime, endTimeMS }];

  const fileList = [];

  if (attraction && attraction.photoURL) {
    fileList.push({
      uid: '-1',
      name: attraction.attractionPhoto,
      url: attraction.photoURL,
      status: 'done',
    });
  }

  return (
    <Formik
      enableReinitialize
      initialValues={defaultValues}
      onSubmit={handleSave}
      validationSchema={AttractionSchema}
    >
      {() => (
        <Form>
          <div className="flex">
            <div className="w-3/4 p-4">
              <FormRow label="AttractionName" errorName="attractionName">
                <Field type="text" name="attractionName" placeholder="Name" />
              </FormRow>
              <DateFormWidget
                label="Dates & Times"
                dates={dates}
                handleDateChange={onDateChange}
              />
            </div>
            <div className="w-1/4 p-4">
              <div className="w-full">
                <FileUpload
                  fileList={fileList}
                  onFileUpload={onFileUpload}
                  onFileDelete={onFileDelete}
                />
              </div>
            </div>
          </div>
          <FormRow errorName="location">
            <Map
              location={attraction.location}
              handleClick={onLocationChange}
            />
          </FormRow>
          <FormRow label="Description">
            <Field
              component="textarea"
              name="attractionDescription"
              placeholder="Attraction Description..."
            />
          </FormRow>
          <FormButtons
            showDelete={attraction.attractionId}
            label="Attraction"
            onDelete={handleRemove}
          />
        </Form>
      )}
    </Formik>
  );
}
